import { graphql } from "../gql";

export const getAuditFindingRuleTypesQueryDoc = graphql(`
  query getAuditFindingRuleTypes {
    auditFindingRuleTypes {
      nodes {
        claimDataType
        deprecated
        description
        displayName
        rationaleTemplate
        type
      }
    }
  }
`);
